import { useQuery } from "react-query";
import { getDealerAddress } from "~/components/Forms/DealerPassportForm2/requests/getDealerAddress";

export default function useGetDealerAddress(dealerId: string) {
  return useQuery({
    queryKey: ["dealerAddress", { dealerId }],
    queryFn: () => getDealerAddress(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
